module.exports = __webpack_public_path__ + "assets/img/3263.a024af91.png";